import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/user.model';
import { UserService } from 'src/app/service/user.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  usersTableColumns: any[];
  users: User[];

  constructor(private userService: UserService, private router: Router, private authService: AuthService) {
   }

  ngOnInit() {
    this.initUsersTable();
    this.refreshData();

  }

  initUsersTable() {
    this.usersTableColumns = [
      { field: 'id', header: 'lblResListID' },
      { field: 'name', header: 'lblResItemsName' },
      { field: 'lastName', header: 'lblResItemsLastName' },
      { field: 'username', header: 'USERNAME' },
      { field: 'phone', header: 'lblPHONE' },
      { field: 'email', header: 'EMAIL' },
      { field: 'role', header: 'lblUSERROLE' }
    ];
  }

  refreshData() {
    this.userService.GetAll().subscribe(data => this.users = data as User[]);
  }


  edit(user: User) {
    this.router.navigateByUrl('/profile-edit/' + user.id);
  }
}
